export default "__VITE_ASSET__B_eJtF_p__"